import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.9 15.1C0 11.2 0 4.8 3.9.9\" class=\"opacity-30\"></path><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.8 12.2c-2.3-2.3-2.3-6.1 0-8.5\" class=\"opacity-60\"></path><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4\"></path><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M15.2 3.8c2.3 2.3 2.3 6.1 0 8.5\" class=\"opacity-60\"></path><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18.1.9C22 4.8 22 11.1 18.1 15\" class=\"opacity-30\"></path>", 5)
  ]))]))
}
export default { render: render }